import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { ClapprImplementation } from '@commoncore/implementation/clappr-implementation';
import { GlobalService } from '@commoncore/services/global.service';
import { PingService } from '@commoncore/services/ping.service';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';

@Component({
  standalone:true,
  selector: 'lib-audio-mini-player',
  templateUrl: './audio-mini-player.component.html',
  styleUrls: ['./audio-mini-player.component.scss'],
  imports:[DependenciesModule]
})
export class AudioMiniPlayerComponent implements OnInit,OnDestroy {
  universalService: any;
  listService: any;
  contextMenuService: any;
  public showExpandedPlayer:boolean=false;
  public clapprImpl : any;
  router:any;
  recalculateHeightService:any;
  @Output() audioPreviewCheck = new EventEmitter(); 
  pingService: any;

  constructor(public globalService:GlobalService) {
    this.setEnvObjects(globalService)
   }

  ngOnInit(): void {
    if(this.universalService.showDirectMiniPlayer) {
      this.universalService.selectedAudioFile = this.universalService.selectedFile
      this.clapprImpl = this.getClapprImplRef();
      this.clapprImpl.openClappr();
      this.universalService.showDirectMiniPlayer = false;
    } else {
      this.clapprImpl = this.getClapprImplRef();
      this.openClappr()
    }
  
  }
  
  getClapprImplRef(){
  //  return new ClapprImplementation(this.globalService)
    return ClapprImplementation.getInstance(this.globalService)
  }

  setEnvObjects(globalService){
    this.universalService = this.globalService.getUniversalServiceRef();
    this.listService = this.globalService.getListServiceRef();
    this.contextMenuService = globalService.getContextMenuServiceRef();
    this.router = globalService.getRouterRef()
    this.recalculateHeightService = globalService.getContainerHeightCalculatorService();
    this.pingService = PingService.getInstance(globalService);
  }


  openClappr() {
    this.openMiniClappr();
  }

  closeMiniPlayer(){
    
    if(this.universalService.player!=undefined && this.universalService.player!=null){
      this.universalService.player.stop();
      this.universalService.player.destroy();
    }
    if(this.clapprImpl.audioplayer!=undefined && this.clapprImpl.audioplayer!=null){
      this.clapprImpl.audioplayer.stop();
      this.clapprImpl.audioplayer.destroy();
    }
    this.universalService.showMiniPlayer = false;
    this.universalService.playAudioFromStart = true;
    this.universalService.showFullViewAudioPlayer = false;
    this.universalService.audioPreview = false;
    //$("#mini_player_root").remove()

    this.recalculateHeightService.sendRecalculateEventToComponents(true);
    if(this.universalService.currentTab == 'audio')
       this.listService.cellclick = false;
  }

  getBackgroundImageUrl(){
    return 'url('+this.clapprImpl.getAudioPosterUrl()+')';
  }

  async openMiniClappr(){
    
    if(this.universalService.player!=undefined && this.universalService.player!=null){
        setTimeout(() => {
            this.clapprImpl.audioplayer = this.universalService.player;
            if(this.universalService.isManualPause == true) {
              this.clapprImpl.audioPlaying = false;
            } else {
              this.clapprImpl.audioPlaying = true;
              this.clapprImpl.audioplayer.play()
            }
            this.pingService.restartPingIntervalWhenSwitchingPreview();
        }, 1);
    }else{
      this.clapprImpl.openClappr();
    }
}   

showFullScreenAudioPlayer(){ 
  if(this.universalService.currentTab == "audio"){
    this.clapprImpl.showFullScreenAudioPlayer();
  }else{ //|| this.router.url.includes('/filter/recents')
    if(this.router.url.includes('/favorites') || this.router.url.includes('/trash') ){
        this.router.navigate(['/audio'], {queryParamsHandling: 'preserve'})
    }

    var Obj = {
      "name":"Audio",
      "iconName":"NeueAudio",
      "slideItemClass":"slide-item-4",
      "id":"audio"
    }
    this.universalService.audioPreviewOpenFromMiniPlayer = true
    this.audioPreviewCheck.emit(Obj)
  }
}

  ngOnDestroy(): void {
    this.pingService.clearInterval();
  }



}
